
import { recipientStepPostConditions, recipientStepPreConditions } from './recipientStepSelectors';

const recipientStepConfig = {
    component: () => import('./RecipientStep'),
    flow: 'buy',
    preConditions: recipientStepPreConditions,
    postConditions: recipientStepPostConditions
};

export default recipientStepConfig;
